export const typography = {
  h1: {
    fontSize: '26px',
    fontWeight: '600',
    letterSpacing: '-0.5px',
    fontFamily: "var(--dp-font)",
  },
  h2: {
    fontSize: '20px',
    fontWeight: '600',
    letterSpacing: '-0.3px',
    fontFamily: "var(--dp-font)",
  },
  h3: {
    fontSize: '16px',
    fontWeight: '600',
    fontFamily: "var(--dp-font)",
  },
  subtitle: {
    fontSize: '14px',
    fontWeight: '600',
    fontFamily: "var(--dp-font)",
  },
  body: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "var(--dp-font)",
  },
  small: {
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: "var(--dp-font)",
  },
  caption: {
    fontSize: '11px',
    fontWeight: '500',
    fontFamily: "var(--dp-font)",
  },
  label: {
    fontSize: '10px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '1.2px',
    fontFamily: "var(--dp-font)",
  },
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
};

export const borderRadius = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  full: '9999px',
  card: '12px',
  button: '8px',
  input: '8px',
};
